import { render, staticRenderFns } from "./Simulacion.vue?vue&type=template&id=bee0e21a&scoped=true"
import script from "./Simulacion.vue?vue&type=script&lang=js"
export * from "./Simulacion.vue?vue&type=script&lang=js"
import style0 from "./Simulacion.vue?vue&type=style&index=0&id=bee0e21a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee0e21a",
  null
  
)

export default component.exports